export default __webpack_public_path__ + "static/media/file.6b0bb939.svg";